module.exports = __webpack_public_path__ + "static/media/screenshot(13).9ba2136d.jpg";